const caseNoTwo = 2;

// eslint-disable-next-line no-restricted-globals
const validateNaN = (value) => value === undefined || isNaN(value);

export const formatDecimalWithPrecision = (value, decimalPlaces = caseNoTwo) => {
  // Convert the value to a number
  const decimalValue = Number(value);
  // Ensure the value is a valid number
  if (validateNaN(decimalValue)) {
    return value;
  }
  // Convert number to string with the specified number of decimal places
  let strValue = decimalValue.toString();
  // Find the position of the decimal point
  const dotIndex = strValue.indexOf('.');
  // If there is no decimal point, add the appropriate number of zeros
  if (dotIndex === -1) {
    strValue += `.${'0'.repeat(decimalPlaces)}`;
  } else {
    // Ensure the string has the correct number of decimal places
    const decimalPart = strValue.substring(dotIndex + 1);
    if (decimalPart.length < decimalPlaces) {
      strValue += '0'.repeat(decimalPlaces - decimalPart.length);
    } else if (decimalPart.length > decimalPlaces) {
      strValue = strValue.substring(0, dotIndex + decimalPlaces + 1);
    } else {
      // do nothings
    }
  }
  return strValue;
};
export const formatToPercentage = (value, decimalPlaces = caseNoTwo) => {
  // Return the same value if it's null or undefined
  if (value === null || value === undefined) {
    return value;
  }
  const formattedString = formatDecimalWithPrecision(value, decimalPlaces);
  if (validateNaN(Number(formattedString))) {
    return formattedString;
  }
  // Append the percentage sign
  return `${formattedString}%`;
};

export const trimString = (value) => {
  if (value === null || value === undefined) {
    return '';
  }
  return value.toString().trim();
};

export const toLowerCaseSafe = (input) => {
  if (typeof input !== 'string') {
    return input;
  }
  return input.toLowerCase();
};
